import { Box } from '@mui/material';
import { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';

import { Album } from '../component/page/album/Album';
import { Inicio } from '../component/page/Inicio';
import { Inventario } from '../component/page/Inventario';
import { Market } from '../component/page/Market';
import { InicioStake } from '../component/page/stake/InicioStake';
import { Stake } from '../component/page/stake/Stake';
import ArenaPage from '../component/page/arena/ArenaPage';
import CasinoPage from '../component/page/casino/CasinoPage';
import NavBar from '../component/ux/NavBar';

export const DashboardRouterGame = () => {
  useEffect(() => {
    function noop() {}

    if (process.env.NODE_ENV !== 'development') {
      console.log = noop;
      console.warn = noop;
      console.error = noop;
    }
  }, []);

  return (
    <Box sx={{ height: '100%' }}>
      <NavBar />

      <Routes>
        <Route path="" element={<Inicio />} />
        <Route path="market" element={<Market />} />
        <Route path="stake" element={<InicioStake />} />
        <Route path="stake/play" element={<Stake />} />
        <Route path="inventory" element={<Inventario />} />
        <Route path="Album" element={<Album />} />
        <Route path="arena" element={<ArenaPage />} />

        {/* HUESO Casino */}
        <Route path="casino" element={<CasinoPage />} />
      </Routes>
    </Box>
  );
};
